<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{ rowIndex + 1 }}</span>
    </td>
    <td class="text-center align-middle">
      {{item.plReqDateString}}
    </td>
    <td class="text-center align-middle">
      {{item.plStatus}}
    </td>
    <td class="text-center align-middle">
      {{item.plProductType}}
    </td>
    <td class="text-center align-middle">
      {{item.plProductName}}
    </td>
    <td class="text-center align-middle">
      {{item.plQuota}}
    </td>
    <td class="text-center align-middle">
      {{item.plQty}}
    </td>
    <td class="text-center align-middle">
      {{item.plAgent}}
    </td>
    <td class="text-center align-middle">
      {{item.plShopActivityName}}
    </td>
    <td class="text-center align-middle">
      {{item.plActivityRemark}}
    </td>
    <td class="text-center align-middle">
      {{item.plReturnDate}}
    </td>

    <td class="text-center align-middle">
      {{item.plOutstanding}}
    </td>
    <td class="form-group">
      <input
        :disabled="item.IsDisabled"
        type="number"
        class="form-control text-center"
        min="0"
        :id="'plReturn' + _uid"
        :name="'plReturn' + _uid"
        v-model="item.plReturn"
        @keydown="preventInvalidChars"
        @input="checkTotal(1)"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        :disabled="item.plIsHide || item.IsDisabled"
        type="number"
        class="form-control text-center"
        min="0"
        :id="'plDamaged' + _uid"
        :name="'plDamaged' + _uid"
        v-model="item.plDamaged"
        @keydown="preventInvalidChars"
        @input="checkTotal(2)"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        :disabled="item.IsDisabled"
        type="number"
        class="form-control text-center"
        min="0"
        :id="'plLost' + _uid"
        :name="'plLost' + _uid"
        v-model="item.plLost"
        @keydown="preventInvalidChars"
        @input="checkTotal(3)"
      />
      <span class="form-text"></span>
    </td>
  </tr>
</template>

<script>
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import router from "../../router";
import Swal from "sweetalert2";
import axios from "axios";
import lodash from "lodash";

export default {
  components: {
    select2,
    datepicker
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    var self = this;

    return {
      CheckStockAnswer: "",
      itemStatus: null,
      itemQty: 0,
      itemProductId: null,
      itemProductType: null,
      itemQuota: null,
      itemAgent: null,
      itemShopActivityId: null,
      requiredRemark: false,
      requiredDate: false
      
    };
  },

  methods: {
    preventInvalidChars(event) {
      if (
        event.key === '.' ||
        event.key === '+' ||
        event.key === '-' ||
        event.key === 'e' ||
        event.key === 'E'
      ) {
        event.preventDefault();
      }
    },
    checkTotal(val) {
      let plReturn = this.item.plReturn !== null && !isNaN(this.item.plReturn) ? parseInt(this.item.plReturn) : 0;
      let plDamaged = this.item.plDamaged !== null && !isNaN(this.item.plDamaged) ? parseInt(this.item.plDamaged) : 0;
      let plLost = this.item.plLost !== null && !isNaN(this.item.plLost) ? parseInt(this.item.plLost) : 0;
      const total = plReturn + plDamaged + plLost;
      if (total > this.item.plOutstanding) {
        Swal.fire("", "ไม่สามารถระบุตัวเลขเกินจำนวนคงเหลือของรายการ", "warning");
        if(val == 1){
          this.item.plReturn = null;
        }else if(val == 2){
          this.item.plDamaged = null;
        }else{
          this.item.plLost = null;
        }
      }
    }
  },
  mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }

    $(self.$refs.plReturnDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows
    });

    $(self.$refs.plReturnDate)
      //.datepicker("update", self.item.plReturnDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        e.date != undefined
          ? (self.item.plReturnDate = moment(e.date))
          : (self.item.plReturnDate = null);
      });
  }
};
</script>

<style lang="scss" scoped>
.table {
    table-layout: auto;
    overflow-x: scroll;
}

.tbody td {
    width: auto;
    overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// App/Components/Borrow/JobBorrowProductReturnItemRow.vue